import * as React from "react";
import { Step, Question } from ".";

// The same questions as in the original Step1Page
const questions: Question[] = [
    {
        question: "Pourquoi les séances de tutorat en ligne doivent-elles être enregistrées? ",
        answers: ["Pour évaluer la performance pédagogique du tuteur. ", 
            "Pour vérifier que les élèves suivent bien les consignes. ", 
            "Pour assurer un bon fonctionnement technique et une utilisation sécuritaire de la plateforme. ", 
            "Pour conserver une preuve en cas de conflit entre le tuteur et l’élève. "],
        correctAnswer: 2,
        explanation: " Les enregistrements des séances en ligne sont une mesure de sécurité et de qualité. Ils permettent de prévenir les comportements inappropriés (du tuteur comme de l’élève), d’intervenir en cas de problème technique ou de mauvaise utilisation de la plateforme et d’assurer une traçabilité minimale des échanges, dans le respect de la confidentialité."
    },
    {
        question: "Que pouvez-vous faire si vous sentez qu’un jeune vit un stress important ou une situation qui dépasse votre rôle? ",
        answers: ["Proposer de lui faire un plan d’intervention. ", 
            "Lui conseiller de consulter un psychologue scolaire. ", 
            "Informer la coordonnatrice ou le coordonnateur. ", 
            "Continuer comme si de rien n’était pour ne pas le brusquer. "],
        correctAnswer: 2,
        explanation: "Lorsque tu constates qu’un élève vit un stress important, un malaise ou une situation qui dépasse le cadre du tutorat (ex. : détresse psychologique, enjeux familiaux, anxiété sévère), la bonne démarche professionnelle est  d’en parler rapidement à la personne responsable (coordonnatrice ou coordonnateur) afin que le jeune reçoive le bon soutien, au bon moment, par les bonnes personnes (ex. : intervenant psychosocial, enseignant, direction, etc.). Cela permet de respecter ton rôle, tout en ne laissant pas l’élève seul avec sa détresse. "
    },
    {
        question: "Un élève-athlète semble constamment oublier ses devoirs, perd ses documents et éprouve des difficultés à gérer son temps. Quelle intervention tutorale est la plus appropriée pour l'aider à améliorer son organisation scolaire ?",
        answers: ["L’aider à structurer sa routine d’entraînement pour maintenir un bon équilibre de vie.",
            "Vérifier régulièrement son agenda, ses échéances de travaux et son matériel scolaire afin de l’accompagner dans l’adoption d’une méthode d’organisation efficace.",
            "Lui demander de tenir un journal quotidien de ses apprentissages pour favoriser la réflexion.",
            "Le laisser expérimenter librement différentes méthodes pour qu’il découvre par lui-même ce qui fonctionne le mieux."],
        correctAnswer: 1,
        explanation: "L’organisation passe par des habitudes concrètes : planification, outils visuels, classement du matériel, repères dans le temps."
    }
];


export function Step5Page() {
    return (
        <Step
            stepNumber="5"
            title="Cinquième capsule"
            videoUrl={`${process.env.PUBLIC_URL}/assets/formation-videos/video5.mp4`}
            redirectURL="/formation/6"
            questions={questions}
        />
    );
} 